export const makeNormal = (str: string): string => {
  const parts = str.split(/--|-|&/);
  return makeCapital(parts);
};

export const makeCapital = (array: string[]): string => {
  return array
    .filter((item) => item.trim())
    .map((item) => {
      const trimmed = item.trim();
      return trimmed[0].toUpperCase() + trimmed.slice(1);
    })
    .join('');
};
